import React, { useEffect, useRef, useState } from 'react';
import useApp from 'hooks/useApp'
import { useRecoilState } from 'recoil'
import { userLogInfoState } from './states'
import { SecureKeypad } from 'components'
import Lib from 'library'
import { useNavigate } from 'react-router-dom';
import Native from 'library/native'
import Global from 'library/Global';

const JoinPassword = () => {

	const App = useApp()

	const navigate = useNavigate()
	const [userInfo, setUserInfo] = useRecoilState(userLogInfoState)
	const [title, setTitle] = useState("비밀번호를 입력 해 주세요.")
	const pass1 = useRef()
	const pass2 = useRef()

	const callback = module => {
		const info = module.get_sessionInfo()
		if (typeof pass1.current === "undefined") {
			pass1.current = info
			setTitle("비밀번호를 다시 한번 입력해주세요.")
			module.refresh()
		} else {
			pass2.current = info
			// DONE: 비번 검증 && 회원가입 동시에 진행

			Global.deviceInfo((deviceInfo) => {

				Lib.post("/api/mb/join/ins/mb", {
					email: userInfo.email,
					secId: pass1.current.sessionId ?? '',
					secToken: pass1.current.secToken ?? '',
					secInput: pass1.current.input,
					secId2: pass2.current.sessionId ?? '',
					secToken2: pass2.current.secToken ?? '',
					secInput2: pass2.current.input,
					termsAgreeList: userInfo.terms,

					pushToken: deviceInfo.pushToken,
					appVer: deviceInfo.appVersion,
					devicModelCd: deviceInfo.model,
					osNm: deviceInfo.os,
					osVer: deviceInfo.osVersion

				}, data => {
					const mbId = data.mbId
						window.localStorage.setItem("mbId", mbId)
						window.localStorage.setItem("didRun", true)
						App.user = {mbId};

						Native.execute("AppManager", "setAuthenticate", result => {
							const json = JSON.parse(result)
							if (json.result !== "Success") {
								console.error(decodeURI(json.result))
							}
						}, {
							userid: mbId
						})
						App.personal = {}
						navigate("/joinSuccess")
				}, data => {
					let msg;
					if(data.data.msg && data.data.code){
						msg = `${data.data.code}: ${data.data.msg}`;
					}else{
						msg =`연동 처리시 오류가 발생했습니다.<br />잠시 후 다시 진행하시기 바랍니다.`
					}
					App.alert(msg, () => {
						module.refresh()
						setTitle("비밀번호를 입력 해 주세요.")
						pass1.current = undefined
						pass2.current = undefined
					})
				})
			})
		}
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		console.log(userInfo)
	}, [])

	return (
		<div className="page">
			{/* <div className="padding center-cont">
				<h3 className="intro-tit">비밀번호를 입력해주세요.</h3>
				<div className="password-box mt_40">
					<span className="on" />
					<span className="on" />
					<span />
					<span />
					<span />
					<span />
				</div>
				<div className="text-red text-align_center mt_20">생년월일은 보안에 취약해요.</div>
			</div> */}
			<SecureKeypad autoClose={false} callback={callback} title={title} />
		</div>
	)
}

export default JoinPassword